//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FeatureGuidePanel from '@/components/new/FeatureGuidePanel.vue'
import { resolveMediaUrl } from '@/utils/mediaUrl'
export default {
  components: { FeatureGuidePanel },
  data () {
    return {
      data: {}, templates: [], cat: 'all', creatingId: null,
      bookIdInput: '', bookNameInput: '', bookLayoutId: null, bookCreating: false,
      cats: [
        { k: 'all', n: '全部' },
        { k: 'body', n: '人体' },
        { k: 'home', n: '家居' },
        { k: 'school', n: '校园' },
        { k: 'food', n: '美食' },
        { k: 'travel', n: '出行' },
        { k: 'daily', n: '日常' },
        { k: 'fantasy', n: '趣味' }
      ]
    }
  },
  computed: {
    backTarget () { return this.$route.query.from === 'mine' ? '/mine' : '/home' },
    limitText () {
      return this.data.limit === 2147483647 ? '不限' : (this.data.limit || 0)
    },
    bodyLayouts () {
      return (this.templates || []).filter(t => (t.category || '') === 'body').slice(0, 6)
    },
    bookLabel () {
      if (!this.bookIdInput) return ''
      return (this.bookNameInput || '词书') + '（' + this.bookIdInput + '）'
    }
  },
  created () {
    this.load()
    this.loadTpl('all')
    this.$ajax.post(this.$api.getUserInfo, { key: 'studyBookID' }).then(result => {
      if (result && result.categoryId) {
        this.bookIdInput = String(result.categoryId)
        this.bookNameInput = result.categoryName || ''
      }
    }).catch(() => {})
  },
  methods: {
    media (u) { return resolveMediaUrl(u) },
    load () { this.$ajax.get(this.$api.mpPalaceMyList).then(r => { this.data = r || {} }).catch(() => {}) },
    loadTpl (c) {
      this.cat = c
      const q = c && c !== 'all' ? ('?category=' + c) : ''
      this.$ajax.get(this.$api.mpTemplateList + q).then(r => {
        this.templates = r || []
        if (!this.bookLayoutId) {
          const body = this.bodyLayouts[0]
          if (body) this.bookLayoutId = body.id
        }
      }).catch(() => { this.templates = [] })
    },
    coverStyle (p) {
      const bg = this.media(p.backgroundImage || p.background_image)
      const color = p.themeColor || p.theme_color || '#1E3A5F'
      if (bg) {
        return { backgroundImage: 'url(' + bg + ')', backgroundSize: 'cover', backgroundPosition: 'center', backgroundColor: color }
      }
      return { background: 'linear-gradient(145deg,' + color + ',#4a90e2)' }
    },
    tplCover (t) {
      const bg = this.media(t.background_image || t.backgroundImage || t.cover_image)
      if (bg) return { backgroundImage: 'url(' + bg + ')', backgroundSize: 'cover', backgroundPosition: 'center' }
      return { background: 'linear-gradient(145deg,#1E3A5F,#4a90e2)' }
    },
    goDetail (id) { this.$router.push({ path: '/mpDetail_display', query: { id } }) },
    quickCustom () { this.$router.push({ path: '/mpCreate_display' }) },
    useTpl (t) {
      if (this.creatingId) return
      this.creatingId = t.id
      this.$ajax.post(this.$api.mpPalaceCreate, {
        template_id: t.id,
        palace_name: t.template_name || t.templateName || '看图宫殿',
        category: t.category || 'body'
      }).then(res => {
        this.$toast && this.$toast('已创建，单词已自动钉到锚点')
        this.$router.push({ path: '/mpDetail_display', query: { id: res.id } })
      }).catch(e => {
        this.$toast && this.$toast(e.message || '创建失败')
      }).finally(() => { this.creatingId = null })
    },
    createFromBook () {
      const bookId = Number(this.bookIdInput)
      if (!bookId) {
        this.$toast && this.$toast('请填写词书ID')
        return
      }
      this.bookCreating = true
      this.$ajax.post(this.$api.mpPalaceCreateFromBook, {
        book_id: bookId,
        book_name: this.bookNameInput || undefined,
        template_id: this.bookLayoutId || undefined
      }).then(res => {
        this.$toast && this.$toast('已生成 ' + (res.bound_count || '') + ' 个锚点单词')
        this.$router.push({ path: '/mpDetail_display', query: { id: res.id } })
      }).catch(e => {
        this.$toast && this.$toast(e.message || '生成失败')
      }).finally(() => { this.bookCreating = false })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/innovation/memory-palace/index.vue